const BASE_URL =
  process.env.REACT_APP_API_URL ||
  "http://gec.energymarketplace.in/gec-backend/api/v1";
const API_V1_BASE_URL = BASE_URL + "/api/v1";
const API_V1 = "/api/v1";
const API_V2 = "/api/v2";
const API_V3 = "/api/v3";

const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: API_V1 + "/auth/login",
    LOGOUT: API_V1 + "/api/auth/logout",
    REFRESH: API_V1 + "/auth/refresh-tokens",
    PROFILE: API_V1 + "/auth/profile",
    ME: API_V1 + "/auth/me",
  },
  UPLOAD_DOCUMENT: API_V1 + "/document/upload",
  CONSUMER_DETAILS_BY_CONSUMER_NO: API_V1 + "/company/consumer/details",
  DROPDOWN: {
    TIMESLOTS: API_V1 + "/dropdowns/timeslots",
  },
  DASHBOARD: {
    OVERVIEW: API_V1 + "/dashboard/admin/overview",
    GENERATOR_GRAPH: API_V1 + "/dashboard/admin/chart/generation",
    CONSUMPTION_GRAPH: API_V1 + "/dashboard/admin/chart/consumption",
    RECENT_REPORT_LIST: API_V1 + "/admin/recent/activity",
    ENERGY_HEATMAP: API_V1 + "/dashboard/admin/chart/heatmap",
    GENERATION_ENERGY_HEATMAP:
      API_V1 + "/dashboard/admin/chart/generation-heatmap",
    ENERGY_HEATMAP_SLOT_DETAILS:
      API_V1 + "/dashboard/consumer/generator-settlements",
    // generator-tooltip-list
    GENERATOR_TOOLTIP_LIST: API_V1 + "/dashboard/admin/generator/tooltip/list",
    GENERATOR_TOLLTIL_SUMMARY:
      API_V1 + "/dashboard/admin/generator/tooltip/summary",
    CONSUMER_TOLLTIL_SUMMARY:
      API_V1 + "/dashboard/admin/consumer/tooltip/summary",
    CONSUMER_TOLLTIL_LIST: API_V1 + "/dashboard/admin/consumer/tooltip/list",
  },
  ENERGY_AUDIT: {
    CONSUMER: {
      COSNUMER_DETAILS: API_V1 + "/dashboard/admin/consumer/audit/summary",
      REPORT: API_V1 + "/dashboard/admin/consumer/audit/list",
    },
    GENERATOR: {
      COSNUMER_DETAILS: API_V1 + "/dashboard/admin/generator/audit/summary",
      REPORT: API_V1 + "/dashboard/admin/generator/audit/list",
    },
  },
  ENERGY_MONITORING_DASHBOARD: {
    GENERATION: {
      GENERATOR: {
        STATS: API_V1 + "/dashboard/admin/chart/generation/summary",
        CHART: API_V1 + "/dashboard/admin/chart/renewable",
        CHART_GRAPH: API_V2 + "/dashboard/admin/chart/renewable",
        DISCOM_ENERGY_GRAPH:
          API_V2 + "/dashboard/admin/chart/all-discom-renewable",
      },
      CONSUMER: {
        STATS: API_V1 + "/dashboard/admin/chart/consumption/summary",
        CHART: API_V1 + "/dashboard/admin/chart/consumption/renewable",
      },
    },
    SETTELED: {
      GENERATOR: {
        STATS: API_V1 + "/dashboard/admin/chart/generation/summary",
        CHART: API_V1 + "/dashboard/admin/chart/generation",
      },
      CONSUMER: {
        STATS: API_V1 + "/dashboard/admin/chart/consumption/summary",
        CHART: API_V1 + "/dashboard/admin/chart/consumption",
      },
    },
  },

  SYSTEM_PERFORMANCE: {
    REALTIME_OVERVIEW: API_V1 + "dashboard/admin/realtime/overview",
    REALTIME_REPORT: API_V1 + "dashboard/admin/realtime/readings",
  },
  ONBOARDING: {
    GENERATORS: {
      REPORT: API_V1 + "/dashboard/generator/list",
      CREATE: API_V1 + "/admin/generators/create",
      UPDATE_STATUS: (id: string) => API_V1 + `/admin/generators/${id}/status`,
      DETAILS: API_V1 + "/dashboard/generator/:consumerId/details",
      AGREGATORS_OPTIONS: "",
    },
    CONSUMER: {
      REPORT: API_V1 + "/dashboard/consumer/list",
      CREATE: API_V1 + "/admin/consumer/create",
      DETAILS: API_V1 + "/dashboard/consumer/:consumerId/details",
      UPDATE_STATUS: (id: string) => API_V1 + `/admin/consumers/${id}/status`,
    },
    ADMIN: {
      REPORT: API_V1 + "",
      CREATE_ADMIN_USER: API_V1 + "/admin/create",
      LIST_ADMIN_USER: API_V1 + "/admin/list",

      UPDATE_STATUS: API_V1 + "",
    },
  },
  SELF_SERVICE: {
    QUERY_REQUEST: {
      ALL_REQUESTS: API_V1 + "/admin/ticket/list",
      POST_QUERY_REQUEST: API_V1 + "/ticket/raise",
      QUERY_DETAILS: API_V1 + "/admin/ticket/details/:ticketId",
      COMMENT: API_V1 + "/ticket/comment",
    },
  },
  GEC_REPORT: {
    REPORT: API_V1 + "/dashboard/admin/ge-certificate",
    REPORT_DETAILS: (id: string) =>
      API_V1 + `/dashboard/admin/ge-certificate/${id}/detail`,
    CERTIFICATE_DETAILS:
      API_V1 + "/dashboard/admin/ge-certificate/:certificateId/info",
    TOKENS_LIST: API_V2 + "/users/admin/tokens/list",
    TOKENS_OWNERSHIP_HISTORY: API_V2 + "/users/admin/tokens/list/transaction",
  },
  TOKENS_MANAGEMENT: {
    DASHBOARD: {
      TOKEN_OVERVIEW: API_V1 + "/dashboard/admin/token/overview",
      TOKEN_REPORT_LIST: API_V1 + "/admin/generator/tokens/list",

      STATS: API_V1 + "",
    },
    GENERATION_REPORT: API_V1 + "/dashboard/admin/token/generation",
  },

  CONFIGURATION: {
    TIME_BLOCK_FORM: API_V1 + "/config/timeblock",
    TIME_BLOCK_REPORT: API_V1 + "/config/timeblock",
    ENERGY_SETTING_FORM: API_V1 + "/config/energy-setting",
    ENERGY_SETTING_REPORT: API_V1 + "/config/energy-setting",
    METRICS: API_V2 + "/configuration/metric",
  },
  COMPANY_LIST: {
    COMAPNY_LIST: API_V2 + "/admin/company/list",
    CONSUMER_LIST: API_V2 + "/admin/company/consumers/list",
  },
  ENERGY_SUMMURY_DASHBOARD: {
    BY_DISCOM: API_V2 + "/admin/company/report",
    BY_COMPANY: API_V2 + "/admin/company/consumers/report",
  },
  BEE_REPORT: {
    RCO_SUBMIT: API_V2 + "/admin/company/rco/report",
    BEE_REPORT: API_V2 + "/admin/company/rco/report",
    TABLE_REPOERT: API_V2 + "/admin/company/rco/report-2",
  },
  TRANSFORMER_ANALYTICS: {
    METER_READINGS: (meterId: string) =>
      API_V2 + `/analytics/meters/${meterId}/readings`,
    KPIS: API_V3 + "/analytics/dt/kpis",
    DUCK_CURVE: (transformerId: string) =>
      API_V3 + `/analytics/dt/${transformerId}/duck-curve`,
    DUCK_CURVE_ANALYSIS: (transformerId: string) =>
      API_V2 + `/analytics/transformers/${transformerId}/duck-curve/analysis`,
    VOLTAGE: (transformerId: string) =>
      API_V3 + `/analytics/dt/${transformerId}/pii/voltage`,
    CURRENT: (transformerId: string) =>
      API_V3 + `/analytics/dt/${transformerId}/pii/current`,
    LOAD_PROFILE: (transformerId: string) =>
      API_V2 + `/analytics/transformers/${transformerId}/load-profile`,
    DUCK_CURVE_SUMMARY: (transformerId: string) =>
      API_V3 + `/analytics/dt/${transformerId}/duck-curve/summary`,
    PII_SUMMARY: (transformerId: string) =>
      API_V3 + `/analytics/dt/${transformerId}/pii/summary`,
    TRANSFORMER_SUMMARY: (transformerId: string) =>
      API_V3 + `/analytics/dt/${transformerId}/summary`,
    TRANSFORMER_CONFIG: (transformerId: string) =>
      API_V2 + `/analytics/transformers/${transformerId}/config`,

    DUCK_CURVE_SCORE_ANALYSIS: (transformerId: string) =>
      API_V3 + `/analytics/dt/${transformerId}/duck-curve/score/analysis`,
    ANALYTICS: (transformerId: string) =>
      API_V2 + `/analytics/transformers/${transformerId}/analytics`,
    PII: (transformerId: string) =>
      `/api/v2/analytics/transformers/${transformerId}/pii`,
  },

  TRI_DASHBOARD: {
    LIST: "/tri-dashboard",
    KPI: API_V2 + "/analytics/impact/summary",
    TREND: "/tri-dashboard/trend",
    DISTRIBUTION: API_V2 + "/analytics/impact/summary/chart",
    FEEDERS: "/tri-dashboard/feeders",
    RISK_MATRIX: API_V2 + "/analytics/impact/feeder-wise-severity/chart",
    RISK_MATRIX_FEEDER: API_V2 + "/analytics/impact/feeder-wise-severity/chart",
    RISK_MATRIX_TRANSFORMER:
      API_V2 + "/analytics/impact/transformer-wise-severity/chart",

    GEO: "/tri-dashboard/geo",
    STATS: "/tri-dashboard/stats",
    TREND_MINI: "",
    IMPACT_SUMMARY: API_V2 + "/analytics/impact/summary",
  },

  FEEDER_IMPACT: {
    LIST: "/feeder-impact",
    DETAIL: (id: string) => `/feeder-impact/${id}`,
    CREATE: "/feeder-impact",
    UPDATE: (id: string) => `/feeder-impact/${id}`,
    DELETE: (id: string) => `/feeder-impact/${id}`,
    STATS: "/feeder-impact/stats",
    GEO_PINS: "/feeder-impact/geo-pins",
    INSIGHTS: "/feeder-impact/insights",
    DASHBOARD: "/feeder-impact/dashboard",

    RISKY_FEEDERS_TRI_SUMMARY: API_V2 + "/analytics/feeders/tri/summary",
    // FEEDER_TIMESERIES: (feederCode: string) =>
    //   API_V2 + `/analytics/feeders/${feederCode}/timeseries`,

    FEEDER_TIMESERIES_BASE: API_V2 + `/analytics/feeders/timeseries`,

    FEEDER_RISK_SUMMARY: API_V2 + "/analytics/feeders/risk-summary",
    ROOT_CAUSE_ANALYSIS:
      API_V2 + "/analytics/transformers/time-series/root-cause-analysis",
    PHASE_ANALYSIS: API_V2 + "/analytics/transformers/phase-analysis",
    TRI_BREAKDOWN: (meterNumber: string) =>
      API_V2 + `/analytics/transformers/${meterNumber}/tri-breakdown`,

    // ✅ NEW - TRI Benchmark
    TRI_BENCHMARK: (meterNumber: string) =>
      API_V2 + `/analytics/transformers/${meterNumber}/tri-benchmark`,
    NEUTRAL_CURRENT_RATIO: API_V2 + "/analytics/neutral-current-ratio",
    MONTHLY_TRI: API_V2 + "/analytics/feeders/tri/monthly",
    TRANSFORMER_MONTHLY_TRI: API_V2 + "/analytics/transformers/tri/monthly",
    RELIABILITY: API_V2 + "/analytics/transformers/reliability",
    LOADING_DISTRIBUTION:
      API_V2 + "/analytics/transformer/load-loss/distribution",
    AUF_TREND: API_V2 + "/analytics/transformer/load-loss/auf-trend",
    LOSS_TREND: API_V2 + "/analytics/transformer/load-loss/trend",
    LOSS_BREAKDOWN: API_V2 + "/analytics/transformer/load-loss/breakdown",
  },

  DTR_INDEX_KPI_IMPACT: {
    // ── Full payloads ────────────────────────────────────────────────────
    DASHBOARD: "/dtr-index-kpi-impact/dashboard",
    STATS: "/dtr-index-kpi-impact/stats",
    OV_ANALYTICS: "/dtr-index-kpi-impact/overvoltage",
    RC_ANALYTICS: "analytics/transformers/reverse-flow/buckets", // rc current
    PU_ANALYTICS: "/dtr-index-kpi-impact/phase-unbalance",

    // ── Granular OV ──────────────────────────────────────────────────────
    OV_TREND: API_V2 + "/analytics/frequency/ov-time-block",
    OV_BUCKETS: API_V2 + "/analytics/frequency/buckets",
    OV_MAGNITUDE: API_V2 + "/analytics/magnitude/buckets",
    OV_DISTRIBUTION: API_V2 + "/analytics/frequency/voltage-distribution",
    OV_DURATION: API_V2 + "/analytics/frequency/overvoltage-duration",
    OV_KPI: "/dtr-index-kpi-impact/overvoltage/kpi",

    // ── Granular RC ──────────────────────────────────────────────────────
    RC_TREND: API_V2 + "/analytics/transformers/reverse-flow/trend",
    RC_SEVERITY: API_V2 + "/analytics/transformers/reverse-flow/buckets", // Magnitude Severity
    RC_CO_OCCURRENCE: "/dtr-index-kpi-impact/reverse-current/co-occurrence",
    RC_CORRELATION: "/dtr-index-kpi-impact/reverse-current/correlation",
    RC_TRI_BREAKDOWN: "/dtr-index-kpi-impact/reverse-current/tri-breakdown",

    // ── Granular PU ──────────────────────────────────────────────────────
    PU_PHASE_LOADING: "/dtr-index-kpi-impact/phase-unbalance/phase-loading",
    PU_UNBALANCE_CAPACITY:
      "/dtr-index-kpi-impact/phase-unbalance/unbalance-capacity",
    PU_RISK_CLUSTERS: "/dtr-index-kpi-impact/phase-unbalance/risk-clusters",
    PU_DAY_NIGHT_CAUSE: "/dtr-index-kpi-impact/phase-unbalance/day-night-cause",

    // ── Insights ─────────────────────────────────────────────────────────
    INSIGHTS: "/dtr-index-kpi-impact/insights",
    CREATE_INSIGHT: "/dtr-index-kpi-impact/insights",
    DELETE_INSIGHT: (id: string) => `/dtr-index-kpi-impact/insights/${id}`,

    FEEDERS: API_V2 + `/dropdown/feeders`,
    TRANSFORMERS: API_V2 + `/dropdown/transformers`,
    SUB_DIVISIONS: API_V2 + `/dropdown/sub-divisions`,
  },

  TRCD_DASHBOARD: {
    LIST: "/trcd-dashboard",
    DETAIL: (id: string) => `/trcd-dashboard/${id}` as const,
    CREATE: "/trcd-dashboard",
    UPDATE: (id: string) => `/trcd-dashboard/${id}` as const,
    DELETE: (id: string) => `/trcd-dashboard/${id}` as const,
    STATS: "/trcd-dashboard/stats",
    PAYLOAD: "/trcd-dashboard/payload",
  },

  DIVISION_PERFORMANCE: {
    DASHBOARD: API_V2 + "/analytics/division/summary",
    KPI_SUMMARY: API_V2 + "/analytics/division/feeders/summary",
    RISKY_FEEDERS: API_V2 + "/analytics/division/feeders/summary",
    RISK_DISTRIBUTION: API_V2 + "/analytics/division/feeders/pie-chart",
    KPI_TREND: API_V2 + "/analytics/division/line-chart",
    PERFORMANCE_BUCKETS: API_V2 + "/analytics/division-performance/buckets",
    MAIN_RISK: API_V2 + "/analytics/division/main-risk",
    TEAM_PERFORMANCE: API_V2 + "/analytics/division-performance/team",
    ACTION_TRACKER: API_V2 + "/analytics/division-performance/actions",
    PRIORITY_ACTIONS:
      API_V2 + "/analytics/division-performance/priority-actions",
    AI_INSIGHTS: API_V2 + "/analytics/division-performance/ai-insights",
  },

  FEEDER_KPI: {
    KPIS: API_V2 + "/analytics/feeders/kpis",
  },

  FEEDER_PERFORMANCE: {
    DASHBOARD: API_V2 + "/analytics/feeder-performance/dashboard",
    IDENTITY: API_V2 + "/analytics/feeder-performance/identity",
    GRIDMETRIC_SCORE: API_V2 + "/analytics/feeder-performance/gridmetric-score",
    FEEDER_RANK: API_V2 + "/analytics/feeder-performance/rank",
    KPI_METRICS: API_V2 + "/analytics/feeder-performance/kpi-metrics",
    CRITICAL_TRANSFORMERS:
      API_V2 + "/analytics/feeder-performance/critical-transformers",
    LOAD_VOLTAGE_PROFILE: API_V2 + "/analytics/feeder-performance/load-voltage",
    TRANSFORMER_HEATMAP:
      API_V2 + "/analytics/feeder-performance/transformer-heatmap",
    RELIABILITY_EVENTS:
      API_V2 + "/analytics/feeder-performance/reliability-events",
    LOSS_ANALYTICS: API_V2 + "/analytics/feeder-performance/loss-analytics",
    ACTION_PRIORITY: API_V2 + "/analytics/feeder-performance/action-priority",
    PHASE_IMBALANCE: API_V2 + "/analytics/feeder-performance/phase-imbalance",
    VOLTAGE_QUALITY: API_V2 + "/analytics/feeder-performance/voltage-quality",
    AI_INSIGHTS: API_V2 + "/analytics/feeder-performance/ai-insights",
    RECOMMENDED_ACTIONS:
      API_V2 + "/analytics/feeder-performance/recommended-actions",

    DETAILS: API_V2 + "/analytics/feeder/details", // ✅ added
    SUMMARY: API_V2 + "/analytics/feeder/summary", // ✅ added
    RANK: API_V2 + "/analytics/feeder/rank", // ✅ added
    DSS_RISK: API_V2 + "/analytics/feeder/dss-risk", // ✅ added
    FEEDER_PERFORMANCE: API_V2 + "/analytics/feeder/performance",
    HEATMAP: API_V2 + "/analytics/feeder/heatmap", // ✅ added
    RELIABILITY: API_V2 + "/analytics/feeder/reliability", // ✅ added
  },
  GRID_PERFORMANCE: {
    DASHBOARD: API_V2 + "/analytics/grid/summary",
    LEADERBOARD: API_V2 + "/analytics/grid/leaderboard",
    RISK_DISTRIBUTION: API_V2 + "/analytics/division/feeders/pie-chart",
    KPI_TREND: API_V2 + "/analytics/division/line-chart",
  },
  DROPDOWNS: {
    MASTER_DATA: API_V2 + "/dropdown/master-data",
    MASTER: API_V2 + "/dropdown/master", // ✅ new unified dropdown API
    SUB_DIVISIONS: API_V2 + "/dropdown/sub-divisions", // legacy (can remove)
  },

  EXPORT_ENERGY: {
    HOURLY: API_V3 + "/analytics/dt/energy",
    DT_DROPDOWN: API_V2 + "/dropdown/dt-masters",
    METER_DROPDOWN: API_V2 + "/dropdown/dt-masters", // same endpoint, with dt_code query
    CONSUMER_HOURLY: API_V3 + "/analytics/dt/energy/consumers", // ✅ new
    FLEET_BILL_IMPACT: (dtCode: string) =>
      API_V3 + `/analytics/dt/${dtCode}/fleet-bill-impact`,
    ENERGY_BALANCE: (dtCode: string) =>
      API_V2 + `/analytics/dt/${dtCode}/energy-balance`,
  },

  EII: {
    DASHBOARD: API_V2 + "/kpis/eii/transformers",
    DT_EXPORT: API_V3 + "/analytics/dt/export-energy",
    RTS_EXPORT: API_V3 + "/analytics/dt/energy/consumers-export",
    HEATMAP: (transformerId: string) =>
      API_V2 + `/kpis/eii/dt/${transformerId}/heatmap`,
  },
  HOSTING_CAPACITY: {
    HC: API_V2 + "/kpis/hc/transformers",
  },

  // Add more endpoints as needed
} as const;

export { BASE_URL, API_ENDPOINTS };
